import ApiAgentInterface from "../../ApiAgentInterface";

class BizApiAgentErrorConverterDecorator extends ApiAgentInterface {
    constructor(bizApiAgent, bizApiAgentErrorConverterStrategy) {
        super();
        this.bizApiAgent = bizApiAgent;
        this.bizApiAgentErrorConverterStrategy = bizApiAgentErrorConverterStrategy;
    }

    get = async (url, headers) => {
        try {
            return await this.bizApiAgent.get(url, headers);
        } catch(error) {
            return this.bizApiAgentErrorConverterStrategy.convert(error);
        }     
    }

    post = async (url, body, headers) => {
        try {
            return await this.bizApiAgent.post(url, body, headers);
        } catch(error) {
            return this.bizApiAgentErrorConverterStrategy.convert(error);
        } 
    }
}

export default BizApiAgentErrorConverterDecorator;